module.exports = __webpack_public_path__ + "img/Konstruktion_Holzdeck.83403d8c.webp";